import React from 'react';
import './index.less';
import { FAEOrderStatusItem } from '@/types/technical';
import { isOwnProperty } from '@/utils/common';

interface SearchFormSelectBtnProps {
  btns: FAEOrderStatusItem[]
  selectId: any
  onclickHandle?: (...args: any) => void
}

const prefix = 'search-form-select-btn';
const SearchFormSelectBtn = (props: SearchFormSelectBtnProps) => {
  const { btns, selectId, onclickHandle} = props;

  return (
    <>
      {btns.map((item: FAEOrderStatusItem, index: number) => {
        return (
          <div
            key={index}
            className={`${prefix}-item flex-center  ${selectId == item.id ? 'active' : ''}`}
            onClick={() => {
              if(selectId == item.id) return
              onclickHandle && onclickHandle(item.id);
            }}
          >
            {item.name}
            {isOwnProperty(item,'count') &&  `(${item.count})`}
          </div>
        );
      })}
    </>

  )
}

export default React.memo(SearchFormSelectBtn);
